import { useFileApi } from "~/api/GeneratedApi";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";

type DeleteFileParams = {
  fileId: number;
  folderDeletePermission?: boolean;
};

export const useDeleteFile = () => {
  const fileApi = useFileApi();

  //   const mutationFunction = ({
  //     fileId,
  //     folderDeletePermission = false,
  //   }: TVariables) =>
  //     fileApi.deleteItem(
  //       fileId,
  //       folderDeletePermission,
  //     ) as unknown as MutationFunction<TData, TVariables>;

  const { mutate: deleteFile } = useCustomMutation(
    ({ fileId, folderDeletePermission = false }: DeleteFileParams) =>
      fileApi.deleteItem(fileId, folderDeletePermission),
  );

  //   const { mutate: testMutate } = useMutation(
  //     (rnd: string) =>
  //       new Promise((resolve) => {
  //         setTimeout(() => {
  //           resolve("resolved");
  //           console.log(rnd);
  //         }, 3000);
  //       }),
  //     { onSuccess: () => console.log("ORIGINAL ONSUC") },
  //   );

  //  mutate("moro", { onSuccess: () => console.log("i did it") });

  return { deleteFile };
};
